export const prod = true;

export const url_prod = "https://services.meep-app.com/";
export const url_homo = "http://services.hm.meep-app.com/";

export const token = "sadfgrth52t432fewrthy5364y3qewvrbety5j7";